import { createTypes } from 'redux-recompose';

export const actions = createTypes(['APPLY_SELECTED_FAILURE_REPORT'], '@@PML');

const actionCreators = {
    APPLY_SELECTED_FAILURE_REPORT: (response) => ({ type: actions.APPLY_SELECTED_FAILURE_REPORT, notification: response }),
};

export default actionCreators;